
export const createApiReducer = (name) => {
    return (state = {}, action) => {
        switch (action.type) {
            case `GET_${name}`:
                return action.payload;
            case `REMOVE_${name}`:
                return {};
            default:
                return state;
        }
    };
};


export const ccApi1 = createApiReducer("CCAPI1");
export const ccApi2 = createApiReducer("CCAPI2");
export const ccApi3 = createApiReducer("CCAPI3");
export const ccApi4 = createApiReducer("CCAPI4");
export const ccApi5 = createApiReducer("CCAPI5");
export const ccApi6 = createApiReducer("CCAPI6");
export const ccApi6b = createApiReducer("CCAPI6B");

export const ccApi7 = createApiReducer("CCAPI7");
export const ccApi8 = createApiReducer("CCAPI8");
export const ccApi9 = createApiReducer("CCAPI9");
export const ccApi10= createApiReducer("CCAPI10");
export const ccApi11= createApiReducer("CCAPI11");
export const ccApi12= createApiReducer("CCAPI12");
export const ccApi14= createApiReducer("CCAPI14");
export const ccApi15= createApiReducer("CCAPI15");
export const ccApi16= createApiReducer("CCAPI16");
export const ccApi17= createApiReducer("CCAPI17");

export const ccApi20= createApiReducer("CCAPI20");
export const ccApi20a= createApiReducer("CCAPI20a");






